<template>
  <div class="auth-form-socials">
    <p class="auth-text">Siga-nos nas redes sociais</p>
    <BaseBox
      class="mt-2"
      display="flex"
      align-items="center"
      justify-content="center"
    >
      <a
        href="https://www.instagram.com/videomedi.teleconsulta/"
        target="_blank"
      >
        <img src="../assets/icons/instagram-icon.svg" alt="instagram" />
      </a>
    </BaseBox>
  </div>
</template>

<script>
export default {
  name: "AuthFormSocials"
};
</script>
